import Api from './BaseRequest';

const Get = () => {
    return Api.Get('/api/document');
};

export default {
    Get,
};
